export default "__VITE_ASSET__C_yzgMB8__"